import { ViewBlockHeader } from "./ViewBlockHeader";
import ValidateInfoSvg from "../../../svg/ValidateInfoSvg";
import useNodeContext from "../../../hooks/useNodeContext";
import { ValidateInfoBlockFormType } from "../../../../types/bert";
import { Box, Divider, Typography } from "@mui/material";
import BlockItem from "./BlockItem";
import { useGetCustomEntitiesQuery } from "@callveriq/redux/services/settings/entity.service";
import {
    useGetAttributeCategoriesQuery,
    useGetAttributeCategoryKeysQuery,
} from "@callveriq/redux/services/settings/auditAiConfig.service";
import { isDefined } from "@callveriq/utils/helper/common.helper";
import CustomSkeleton from "@callveriq/components/custom_components/Skeleton";
const EntityOrAttributeCategory = ({
    fields,
    staticInfo,
}: {
    fields: ValidateInfoBlockFormType["validateFields"];
    staticInfo?: string;
}) => {
    const { data: entities, isFetching: isLoadingEntities } =
        useGetCustomEntitiesQuery();
    const getEntityName = (entityId: number | null) => {
        return entities?.find((entity) => entity.id === entityId)?.name;
    };
    const getCategoryName = (categoryId: number | null) => {
        return categories?.find((category) => category.id === categoryId)?.name;
    };
    const { data: selectedKey, isLoading: isLoadingSelectedKey } =
        useGetAttributeCategoryKeysQuery(
            {
                id: Number(fields.attributeCategoryKey),
            },
            {
                skip: !isDefined(fields.attributeCategoryKey),
            }
        );
    const { data: categories, isFetching: isLoadingCategories } =
        useGetAttributeCategoriesQuery();
    if (isLoadingEntities || isLoadingSelectedKey || isLoadingCategories) {
        return (
            <div>
                <CustomSkeleton rows={2} />
            </div>
        );
    }
    if (fields.entity) {
        return (
            <BlockItem
                title="Chosen Entity"
                value={getEntityName(fields.entity)}
            />
        );
    }
    if (fields.attributeCategory) {
        return (
            <div className="flex justify-between">
                <BlockItem
                    title="Chosen Attribute Category"
                    value={getCategoryName(fields.attributeCategory)}
                />
                <BlockItem
                    title="Chosen Key"
                    value={selectedKey?.results[0]?.name}
                />
            </div>
        );
    }
    return <BlockItem title="Static Information" value={staticInfo} />;
};
const ValidateInfo = () => {
    const { nodeDataToUpdate } = useNodeContext() as {
        nodeDataToUpdate: ValidateInfoBlockFormType;
    };
    return (
        <div>
            <ViewBlockHeader icon={<ValidateInfoSvg />} title="Validate Info" />
            <Box
                className="flex flex-col "
                sx={{
                    p: 2,
                    gap: 1.5,
                }}
            >
                <BlockItem title="Block Name" value={nodeDataToUpdate.name} />
                <Divider />
                <EntityOrAttributeCategory
                    fields={nodeDataToUpdate.validateFields}
                />
                <Divider />
                <div className="flex justify-between">
                    <BlockItem
                        title="Selected Operator"
                        value={nodeDataToUpdate.operator}
                    />
                    {nodeDataToUpdate.matchType &&
                        nodeDataToUpdate.operator?.toLowerCase() ===
                            "equals" && (
                            <BlockItem
                                title="Selected Match"
                                value={
                                    <span className="capitalize">
                                        {nodeDataToUpdate.matchType} Match
                                    </span>
                                }
                            />
                        )}
                </div>
                <Divider />
                <EntityOrAttributeCategory
                    fields={nodeDataToUpdate.validateWithFields}
                    staticInfo={nodeDataToUpdate.value as string}
                />
                <Box className="">
                    <Typography
                        component="span"
                        color="danger"
                        variant="textXs"
                    >
                        Note:
                    </Typography>
                    <Typography
                        component="span"
                        color="textColor.666"
                        variant="textXs"
                        sx={{
                            lineHeight: "0px",
                        }}
                    >
                        The Entities are dynamically filtered based on the
                        selected Attribute Category key.
                    </Typography>
                </Box>
            </Box>
        </div>
    );
};

export default ValidateInfo;
